import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationNL from './locales/nl.json';
import translationAR from './locales/ar.json';

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  nl: {
    translation: translationNL
  },
  ar: {
    translation: translationAR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    // Language detection options
    detection: {
      order: ['localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'preferredLanguage',
      lookupSessionStorage: 'currentLanguage',
      caches: ['localStorage', 'sessionStorage']
    },
    
    interpolation: {
      escapeValue: false
    },
    
    // React i18next options
    react: {
      useSuspense: false
    },
    
    // Ensure language is loaded before rendering
    load: 'languageOnly',
    
    // Preload all languages
    preload: ['en', 'fr', 'nl', 'ar']
  });

export default i18n; 